import { useCallback } from 'react';
import { useApiGestao } from 'servicos/api-gestao/base';

export function useGetTokenFacebook() {
  const { invocarApi, ...outrasPropriedades } = useApiGestao();

  const getTokenFacebook = useCallback(
    async (accessToken: string) => {
      const ret = await invocarApi({
        url: `token/facebook/${accessToken}`,
        enviarTokenIntegracao: true
      });

      let retError = {};
      //ERRO NO TOKEN
      if (ret.statusCode === 401) {
        retError = await invocarApi({
          url: `token/facebook/${accessToken}`,
          enviarTokenIntegracao: true,
          forcarTokenIntegracao: true
        });
      }
      return { ...ret, ...retError };
    }
    ,
    [invocarApi]
  );

  return {
    ...outrasPropriedades,
    getTokenFacebook,
  };
}
